import DynamicImagePreview, {
  getDynamicImageTag,
} from 'components/flowBuilder/components/messagePreview/components/DynamicImagePreview';
import ContactCardPreview from 'components/messagePreview/components/ContactCardPreview';
import StaticImagePreview, {
  isStaticImageURL,
} from 'components/messagePreview/components/StaticImagePreview';
import StaticVideoPreview, {
  isStaticVideoURL,
} from 'components/messagePreview/components/StaticVideoPreview';
import styled from 'styled-components';
import { isContactCardURL } from 'utils/contactCards';

const StyledMediaPreview = styled.div<{
  rounded?: boolean;
  withBorder?: boolean;
}>`
  border: ${({ withBorder }) =>
    withBorder ? '1px solid var(--border-color-extra-dim)' : 'none'};
  border-radius: ${({ rounded }) =>
    rounded ? 'var(--border-radius-small)' : '0'};
  overflow: hidden;
  width: 100%;
`;

interface MediaPreviewProps {
  mediaUrl?: string | null;
  thumbnailUrl?: string | null;
  rounded?: boolean;
  showContactCardLink?: boolean;
  withBorder?: boolean;
}

const MediaPreview = ({
  mediaUrl,
  thumbnailUrl,
  rounded = true,
  showContactCardLink,
  withBorder = false,
}: MediaPreviewProps) => {
  if (!mediaUrl) return null;

  const dynamicImage = getDynamicImageTag(mediaUrl);

  const isContactCard = isContactCardURL(mediaUrl);

  const isStaticVideo = isStaticVideoURL(mediaUrl);
  const isStaticImage = isStaticImageURL(mediaUrl);

  return (
    <StyledMediaPreview rounded={rounded} withBorder={withBorder}>
      {dynamicImage && <DynamicImagePreview description={dynamicImage.label} />}
      {isContactCard && <ContactCardPreview showLink={showContactCardLink} />}
      {isStaticVideo && (
        <StaticVideoPreview url={mediaUrl} poster={thumbnailUrl ?? undefined} />
      )}
      {isStaticImage && <StaticImagePreview url={mediaUrl} />}
    </StyledMediaPreview>
  );
};

export default MediaPreview;
